import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'auth-login-failed',
  templateUrl: './login-failed.component.html',
  styleUrls: ['./login-failed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginFailedComponent {}
